import { render, staticRenderFns } from "./branchBar.vue?vue&type=template&id=9b6ec860&scoped=true&"
import script from "./branchBar.vue?vue&type=script&lang=js&"
export * from "./branchBar.vue?vue&type=script&lang=js&"
import style0 from "./branchBar.vue?vue&type=style&index=0&id=9b6ec860&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6ec860",
  null
  
)

export default component.exports